import { Slot } from '@radix-ui/react-slot'
import { cn } from '@seen/ui'
import type { ComponentPropsWithoutRef, JSX } from 'react'

export interface DialogContentProps extends ComponentPropsWithoutRef<'div'> {
  asChild?: boolean
}

export function DialogContent({
  asChild,
  className,
  ...delegated
}: DialogContentProps): JSX.Element {
  const Comp = asChild ? Slot : 'div'
  return (
    <Comp
      className={cn('flex flex-col gap-3 px-6 pt-2 pb-6', className)}
      {...delegated}
    />
  )
}
